
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bUM6a", function(module, exports) {

$parcel$export(module.exports, "EndOfTrialMessageSharedGlobalComponent", () => $c6fe7d5433dc8f95$export$d575643e40b02bf0);

var $2iMSn = parcelRequire("2iMSn");

var $eUqFw = parcelRequire("eUqFw");

var $bHRuU = parcelRequire("bHRuU");
var $f9KE2 = parcelRequire("f9KE2");
var $9FEvp = parcelRequire("9FEvp");

var $iWLL0 = parcelRequire("iWLL0");

var $7ZZxN = parcelRequire("7ZZxN");

var $6q8F1 = parcelRequire("6q8F1");

var $5ge6s = parcelRequire("5ge6s");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $3qf87 = parcelRequire("3qf87");

var $cPEpP = parcelRequire("cPEpP");

var $1JlVa = parcelRequire("1JlVa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $g4G5S = parcelRequire("g4G5S");

var $ejxbt = parcelRequire("ejxbt");

var $56uMT = parcelRequire("56uMT");

var $8Kzvy = parcelRequire("8Kzvy");
const $c6fe7d5433dc8f95$export$e4cfe87fe34415bd = (environment, variables)=>(0, $iWLL0.fetchQuery)(environment, (0, $2iMSn.default), variables).toPromise().then((data)=>{
        const tenantContexts = data?.tenantContexts || [];
        const entitlement = tenantContexts[0]?.entitlementInfo?.entitlement;
        const ccpTrialLength = entitlement?.offering?.trial?.lengthDays;
        // firstPreDunningEndTimestamp is returned as microseconds as opposed to milliseconds
        const firstPreDunningEndTimestampMicroseconds = entitlement?.preDunning?.firstPreDunningEndTimestamp;
        if (!ccpTrialLength || !firstPreDunningEndTimestampMicroseconds) return null;
        const preDunningEndTimestamp = firstPreDunningEndTimestampMicroseconds / 1000;
        const trialEndTimestamp = (0, $f9KE2.default)((0, $9FEvp.default)(new Date(preDunningEndTimestamp), 14));
        const trialStartTimestamp = (0, $f9KE2.default)((0, $9FEvp.default)(new Date(trialEndTimestamp), ccpTrialLength));
        return {
            preDunningEndTimestamp: preDunningEndTimestamp,
            trialEndTimestamp: trialEndTimestamp,
            trialStartTimestamp: trialStartTimestamp
        };
    });
const $c6fe7d5433dc8f95$var$EndOfTrialMessageSharedGlobalComponentImpl = ({ supportedEotmProjectType: supportedEotmProjectType })=>{
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const { openModal: openModal } = (0, $eUqFw.useContext)((0, $3qf87.ModalContext));
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(supportedEotmProjectType);
    const entitlementDetails = productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    const edition = (0, $6WXNs.getEditionForProject)(supportedEotmProjectType, appEditions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: { load: load } } = (0, $6j4bv.useEntryPoint)((0, $1JlVa.editionAwarenessTrialModalEntryPoint), {
        cloudId: cloudId,
        productKey: productKey,
        jiraProjectType: (0, $7ZZxN.convertToJiraProjectType)(supportedEotmProjectType),
        jiraApplicationKey: (0, $eIp1n.getApplicationKeyForProject)(supportedEotmProjectType)
    });
    const hasFetchedMessageData = (0, $eUqFw.useRef)(false);
    const { cohort: cohort, fireStatsigExperimentExposure: fireStatsigExperimentExposure, flagKey: flagKey } = (0, $8Kzvy.getEndOfTrialMessageExperiment)(supportedEotmProjectType);
    const shouldFetchPreDunning = edition === (0, $6WXNs.STANDARD_EDITION) && billingSourceSystem === 'CCP' && !entitlementDetails?.trialEndTime;
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, (0, $ejxbt.STARGATE_URL)), [
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        hasFetchedMessageData.current = false;
    }, [
        shouldFetchPreDunning
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchPreDunningAndShowModal = async ()=>{
            // ensure message data is only fetched once as load is new object on each render
            if (!shouldFetchPreDunning || hasFetchedMessageData.current) return;
            hasFetchedMessageData.current = true;
            const endOfTrialMessageData = await $c6fe7d5433dc8f95$export$e4cfe87fe34415bd(relayEnvironment, {
                cloudId: cloudId,
                hamsProductKey: productKey
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'endOfTrialMessageData fetched', {
                cloudId: cloudId,
                productKey: productKey,
                endOfTrialMessageData: endOfTrialMessageData
            });
            if (!endOfTrialMessageData) return;
            const preDunningDaysLeft = (0, $bHRuU.default)(new Date(endOfTrialMessageData.preDunningEndTimestamp), new Date());
            const eotmAudience = (0, $8Kzvy.getEndOfTrialMessageAudience)(preDunningDaysLeft, supportedEotmProjectType);
            const shouldShowModal = eotmAudience && await coordinationClient.start(eotmAudience);
            if (!shouldShowModal) return;
            fireStatsigExperimentExposure();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'endOfTrialMessaging', {
                flagKey: flagKey,
                entitlementDetails: entitlementDetails,
                cohort: cohort,
                growthInitiative: 'transmuters',
                projectType: supportedEotmProjectType,
                edition: edition
            });
            if (cohort !== 'variation') return;
            load();
            openModal(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                    id: "endOfTrialMessageModalContainer",
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56uMT.ModalSkeleton), {
                        onClose: onClose
                    }),
                    runtimeProps: {
                        onClose: onClose,
                        projectType: supportedEotmProjectType,
                        edition: edition,
                        endOfTrialMessageData: endOfTrialMessageData,
                        shouldCloseOnOverlayClick: false
                    }
                }));
            coordinationClient.stop(eotmAudience);
        };
        fetchPreDunningAndShowModal();
    }, [
        cloudId,
        cohort,
        coordinationClient,
        createAnalyticsEvent,
        edition,
        entryPointReferenceSubject,
        fireStatsigExperimentExposure,
        load,
        openModal,
        productKey,
        supportedEotmProjectType,
        relayEnvironment,
        shouldFetchPreDunning,
        flagKey,
        entitlementDetails
    ]);
    return null;
};
const $c6fe7d5433dc8f95$export$d575643e40b02bf0 = ()=>{
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    if (!(0, $6q8F1.isSupportedEotmProjectType)(projectType)) return null;
    const { isEnrolled: isEnrolled } = (0, $8Kzvy.getEndOfTrialMessageExperiment)(projectType);
    if (!isEnrolled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6fe7d5433dc8f95$var$EndOfTrialMessageSharedGlobalComponentImpl, {
        supportedEotmProjectType: projectType
    });
};

});
parcelRegister("2iMSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe9689bfc7d7d7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a98fdaad5d675dc3710c63666872b68>>
 * @relayHash 470ef2ef4588460fe03eed125f91c1ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ae2859b3660f66947e4759260c0a6a95ff3ed9db685bacfe757c96b78662340
const $bfe9689bfc7d7d7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inPreDunning": true
                    }
                ]
            }
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CcpOfferingTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lengthDays"
                    }
                ]
            }
        ],
        "type": "CcpOffering"
    }, v5 = {
        "kind": "ScalarField",
        "name": "firstPreDunningEndTimestamp"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3ae2859b3660f66947e4759260c0a6a95ff3ed9db685bacfe757c96b78662340",
            "metadata": {},
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bfe9689bfc7d7d7a$var$node.hash = "dabc51d1fad1542ebb0e4bbf406d549e";
var $bfe9689bfc7d7d7a$export$2e2bcd8739ae039 = $bfe9689bfc7d7d7a$var$node;

});

parcelRegister("6q8F1", function(module, exports) {

$parcel$export(module.exports, "isSupportedEotmProjectType", () => $6e7c205eaf647115$export$177b0b5ff46e69ac);

var $7ZZxN = parcelRequire("7ZZxN");
const $6e7c205eaf647115$var$SUPPORTED_EOTM_PROJECT_TYPES = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)
];
const $6e7c205eaf647115$export$177b0b5ff46e69ac = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !!projectType && $6e7c205eaf647115$var$SUPPORTED_EOTM_PROJECT_TYPES.includes(projectType));
};

});

parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $6uNFR = parcelRequire("6uNFR");
var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer') && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    const isCoordinationClientChoreographed = client.enableChoreographer;
    // We need to wrap this context value with useMemo otherwise it always triggers
    // re-render of all children when parent of CoordinationClient re-render
    const choreographedStatusContextValue = (0, $eUqFw.useMemo)(()=>({
            isAlreadyChoreographedAtAncestor: isCoordinationClientChoreographed
        }), [
        isCoordinationClientChoreographed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: choreographedStatusContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        const startMessageAsync = async ()=>{
            const disposition = await startMessage();
            onMessageDisposition?.(disposition);
        };
        startMessageAsync();
        return ()=>{
            stopMessage();
        };
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage
    ]);
    return shouldRender;
};
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);

});

parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $eI5EY = parcelRequire("eI5EY");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return (0, $eI5EY.fg)('po-jira-choreographer-api-integration') ? !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType) : false;
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});



parcelRegister("1JlVa", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessTrialModalEntryPoint", () => $a8110d5cf72f3ec9$export$de2f955c8fd39788);

var $hsi1O = parcelRequire("hsi1O");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a8110d5cf72f3ec9$export$de2f955c8fd39788 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("jhrVn")), {
        moduleId: "3928dd3c"
    }),
    // @ts-expect-error - JiraApplicationKey in AGG schema does not support CUSTOMER_SERVICE
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, jiraProjectType: jiraProjectType, jiraApplicationKey: jiraApplicationKey })=>({
            extraProps: {
                productKey: productKey
            },
            entryPoints: {},
            queries: {
                editionAwarenessTrialModalQueryRef: {
                    parameters: (0, $hsi1O.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectType: jiraProjectType,
                        jiraApplicationKey: jiraApplicationKey
                    }
                }
            }
        })
});

});
parcelRegister("hsi1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b3391d5882a6fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff1eb35d4b1573d74dea54c4862ab3d5>>
 * @relayHash 1a171caa1697d948acf3d32b1588f8b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d5369007f52fd194926961741affa5e9d1f74ecb8db80b62bdc3e99df454ac10
const $72b3391d5882a6fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d5369007f52fd194926961741affa5e9d1f74ecb8db80b62bdc3e99df454ac10",
        "metadata": {},
        "name": "main_EditionAwarenessTrialModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $72b3391d5882a6fe$export$2e2bcd8739ae039 = $72b3391d5882a6fe$var$node;

});

parcelRegister("jhrVn", function(module, exports) {

var $chRvw = parcelRequire("chRvw");
module.exports = Promise.all([
    $chRvw("h2MrD"),
    $chRvw("bYT2S"),
    $chRvw("c9VNC")
]).then(()=>parcelRequire('579gd'));

});


parcelRegister("g4G5S", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $c8efb20e27e18352$export$e02d6385b5d47f5d);

var $gd0Sp = parcelRequire("gd0Sp");
const $c8efb20e27e18352$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

parcelRegister("56uMT", function(module, exports) {

$parcel$export(module.exports, "ModalSkeleton", () => $8c0b5703c647f8ca$export$ba38383f4d71feb1);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $1zbEq = parcelRequire("1zbEq");
const $8c0b5703c647f8ca$export$ba38383f4d71feb1 = ({ onClose: onClose, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: 968,
        height: 576
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null));

});

parcelRegister("8Kzvy", function(module, exports) {

$parcel$export(module.exports, "getEndOfTrialMessageAudience", () => $07630406621a6851$export$35c002d8cb752227);
$parcel$export(module.exports, "getEndOfTrialMessageExperiment", () => $07630406621a6851$export$cc0a7ba2b7691053);

var $jG2Eu = parcelRequire("jG2Eu");

var $7ZZxN = parcelRequire("7ZZxN");

var $6q8F1 = parcelRequire("6q8F1");

var $79xbN = parcelRequire("79xbN");

var $ejxbt = parcelRequire("ejxbt");
const $07630406621a6851$export$35c002d8cb752227 = (preDunningDaysLeft, projectType)=>{
    if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) return (0, $ejxbt.END_OF_TRIAL_MESSAGE_AUDIENCES)[projectType][preDunningDaysLeft];
    return undefined;
};
const $07630406621a6851$var$getEndOfTrialMessageExperimentConfig = (projectType)=>{
    if (!(0, $6q8F1.isSupportedEotmProjectType)(projectType)) throw new Error(`Invalid EOTM projectType: ${projectType}`);
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) {
        const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('end_of_trial_ep_message_jpd');
        return {
            config: endOfTrialMessageConfig,
            fireStatsigExperimentExposure: fireStatsigExperimentExposure,
            flagKey: 'end_of_trial_ep_message_jpd'
        };
    }
    const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('end_of_trial_ep_message_jsm');
    return {
        config: endOfTrialMessageConfig,
        fireStatsigExperimentExposure: fireStatsigExperimentExposure,
        flagKey: 'end_of_trial_ep_message_jsm'
    };
};
const $07630406621a6851$export$cc0a7ba2b7691053 = (projectType)=>{
    if (!(0, $6q8F1.isSupportedEotmProjectType)(projectType)) return {
        isEnrolled: false,
        cohort: 'not-enrolled',
        fireStatsigExperimentExposure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    const { config: config, fireStatsigExperimentExposure: fireStatsigExperimentExposure, flagKey: flagKey } = $07630406621a6851$var$getEndOfTrialMessageExperimentConfig(projectType);
    const cohort = config.get('cohort', 'not-enrolled');
    return {
        isEnrolled: cohort !== 'not-enrolled',
        cohort: cohort,
        fireStatsigExperimentExposure: fireStatsigExperimentExposure,
        flagKey: flagKey
    };
};

});



//# sourceMappingURL=async-end-of-trial-message-shared.e6228e59.js.map
